"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSwitcherArrowActive(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 37"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "switcher-arrow-active_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "switcher-arrow-active_svg__c",
    width: "108.3%",
    height: "102.7%",
    x: "-4.2%",
    y: "-1.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "switcher-arrow-active_svg__b",
    d: "M617 2983h2.435a2 2 0 011.824 1.18l7.741 17.238-7.743 17.395a2 2 0 01-1.827 1.187H617v-37z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-617 -2983)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#switcher-arrow-active_svg__a)",
    xlinkHref: "#switcher-arrow-active_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    filter: "url(#switcher-arrow-active_svg__c)",
    xlinkHref: "#switcher-arrow-active_svg__b"
  })));
}

var MemoSvgSwitcherArrowActive = /*#__PURE__*/React.memo(SvgSwitcherArrowActive);
var _default = MemoSvgSwitcherArrowActive;
exports["default"] = _default;